import React from 'react';
import { View, Text, TouchableOpacity, Modal, Pressable, ScrollView, StyleSheet } from 'react-native';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';

interface ConfigDrawerProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
  footer?: React.ReactNode;
  width?: number;
  children: React.ReactNode;
}

/** Right side drawer. Tables on the configuration page are read only; every edit happens here. */
const ConfigDrawer: React.FC<ConfigDrawerProps> = ({
  title,
  subtitle,
  onClose,
  footer,
  width = 520,
  children,
}) => (
  <Modal visible transparent animationType="fade" onRequestClose={onClose}>
    <View style={styles.root}>
      <Pressable style={styles.scrim} onPress={onClose} accessibilityLabel="Close drawer" />
      <View style={[styles.panel, { width }]} accessibilityViewIsModal>
        <View style={styles.head}>
          <View style={styles.headText}>
            <Text style={styles.title}>{title}</Text>
            {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
          </View>
          <TouchableOpacity onPress={onClose} accessibilityLabel="Close" hitSlop={8}>
            <Text style={styles.close}>✕</Text>
          </TouchableOpacity>
        </View>
        <ScrollView style={styles.body} contentContainerStyle={styles.bodyContent}>
          {children}
        </ScrollView>
        {footer ? <View style={styles.foot}>{footer}</View> : null}
      </View>
    </View>
  </Modal>
);

const styles = StyleSheet.create({
  root: { flex: 1, flexDirection: 'row', justifyContent: 'flex-end' },
  scrim: { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.35)' },
  panel: {
    maxWidth: '100%',
    height: '100%',
    backgroundColor: AdminColors.bgSurface,
    shadowColor: '#000',
    shadowOffset: { width: -2, height: 0 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
  },
  // .drawer-head / .drawer-body / .drawer-foot: 16px 24px, 24px, 16px 24px
  head: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    paddingHorizontal: 24,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.gray25,
  },
  headText: { flex: 1 },
  title: {
    fontSize: 20,
    lineHeight: 28,
    fontWeight: '700',
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.bold,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 18,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    marginTop: 2,
  },
  close: { fontSize: 16, color: AdminColors.textSecondary, fontFamily: FontFamily.bold },
  body: { flex: 1 },
  bodyContent: { padding: 24, gap: 18 },
  foot: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    paddingHorizontal: 24,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: AdminColors.gray25,
  },
});

export default ConfigDrawer;
